module.exports = "https://trybtryb-legacy.web.app/img/dotted-special-mobile.edab8e23.svg";